/* eslint-disable no-catch-shadow */
/* eslint-disable no-shadow */

/* eslint-disable no-param-reassign */

import axios from 'axios';
import { REFRESH_TOKEN, TOKEN } from './Storage/Constants';
import { getValueIntoStorage, _setDataToStorage } from './Storage/Functions';

const libra = require('axios/lib/adapters/xhr');

// axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

const axiosApi = axios.create({
  // baseURL: process.env.REACT_APP_API_URL, Staging
  timeout: 60000,
  headers: { authorization: 'foobar' },
  adapter: libra,
  // httpAgent: new http.Agent({keepAlive: true}),
});

// Add a request interceptor
axiosApi.interceptors.request.use(
  async (config) => {
    try {
      const Token = getValueIntoStorage(TOKEN);
      const accessToken = Token;
      config.headers = {
        Authorization: `${accessToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      return config;
    } catch (error) {
      console.log('axiosApi.interceptors.request error >>', error);
      return Promise.reject(error);
    }
  },
  async (error) => Promise.reject(error),

);

// Add a response interceptor
axiosApi.interceptors.response.use(
  async (response) => {
    try {
      return response;
    } catch (error) {
      console.log('axiosApi.interceptors.response error >>', error);
      return Promise.reject(error);
    }
  },
  async (error) => {
    try {
      const originalRequest = error.config;
      if (error.request && error.request.status === 401) {
        const refreshToken = getValueIntoStorage(REFRESH_TOKEN);
        if (refreshToken && refreshToken !== undefined && refreshToken !== 'undefined') {
          console.log(refreshToken);
          let createNewToken = await fetch(
            `https://securetoken.googleapis.com/v1/token?key=${process.env.VUE_APP_FIREBASE_API_KEY}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: `grant_type=refresh_token&refresh_token=${refreshToken}`,
            },
          );
          createNewToken = await createNewToken.json();
          console.log(error.request, 'error.request');
          console.log('token regenerated>>');
          _setDataToStorage(TOKEN, createNewToken.access_token);
          _setDataToStorage(REFRESH_TOKEN, createNewToken.refresh_token);
          originalRequest.headers.authorization = `${createNewToken.access_token}`;
          const data = await axiosApi(originalRequest);
          return data;
        }
      }
      return Promise.reject(error);
    } catch (error) {
      console.log('axiosApi.interceptors.response error >>', error);
      return Promise.reject(error);
    }
  },
);

// module.exports = axiosApi;
export default axiosApi;

/* eslint-enable no-param-reassign */
